import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-form';
import Popup from '../../Popup';
import { CheckBox, Textarea } from '../../Form';

const MessagePopUp = ({
    onCloseClick,
    onSendClick,
    title,
    subTitle,
    placeHolder,
    sendText,
    successMessage,
    errorMessage,
    isSending,
    isSuccess,
    isError,
}) => {
    let resultDisplay;
    if (isSuccess) {
        resultDisplay = successMessage || 'Your request processed successfully.';
    } else if (isError) {
        resultDisplay = errorMessage || 'Error processing your request.';
    }

    return (
        <Popup
            className={`popup-md`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                style: {
                    maxHeight: '100%',
                },
            }}
        >
            <Form
                onSubmit={values => onSendClick({ values })}
                defaultValues={{
                    organizerCopy: true,
                }}
            >
                {({ submitForm }) => {
                    return (
                        <form onSubmit={submitForm} id="reportConversationForm">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h5 className={`text-uppercase`}>{title}</h5>
                                    </div>
                                    {(isSuccess || isError) ? (
                                        <>
                                            <div className="col-12 mt16 mb24">
                                                {resultDisplay}
                                            </div>
                                            <div className="col-12 mt8">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    onClick={onCloseClick}
                                                >
                                                    OK
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-12 mt16">
                                                <Textarea
                                                    description={subTitle}
                                                    id="notes"
                                                    field="notes"
                                                    rows="5"
                                                    placeholder={placeHolder}
                                                />
                                            </div>
                                            <div className="col-12 mt16">
                                                <CheckBox
                                                    customLabel="Send message to event organizer"
                                                    id="organizerCopy"
                                                    field="organizerCopy"
                                                />
                                            </div>
                                            <div className="col-12 mt8">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={isSending}
                                                >
                                                    {isSending ? <span><i className="fas fa-circle-notch fa-spin" />&nbsp;Processing...</span> : sendText}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </Popup>
    );
};

export default MessagePopUp;

MessagePopUp.propTypes = {
    title: PropTypes.string,
    placeHolder: PropTypes.string,
    sendText: PropTypes.string,
    successMessage: PropTypes.string,
    isSending: PropTypes.bool,
    isSuccess: PropTypes.bool,
    isError: PropTypes.bool,
};

MessagePopUp.defaultProps = {
    title: '',
    placeHolder: '',
    sendText: '',
    successMessage: 'Your request processed successfully.',
    isSending: false,
    isSuccess: null,
    isError: null,
};
